'use strict';

var App = require('app');
var BaseDeviceController = require('components/devices/controllers/base_device_controller');
var TemperatureDialogView = require('components/devices/views/controller/temperature_view');
var OperatingModeDialogView = require('components/devices/views/controller/operating_mode_dialog_view');
var TimeProgramDialogView = require('components/devices/views/controller/time_program_dialog_view');
var SchemaSettingsDialogView = require('components/scheme/views/settings_dialog_view');

var ControllerController = BaseDeviceController.extend({
    showTemperatureDialogView: function (e, handlingView) {
        var selectedMode = $(e.currentTarget).attr('id');
        App.showModal(
            new TemperatureDialogView({
                mode: selectedMode,
                controller: this,
                handleView: handlingView,
                model: handlingView.model,
            })
        );
    },

    showOperatingModeDialogView: function (e, handlingView) {
        App.showModal(
            new OperatingModeDialogView({
                handleView: handlingView,
                model: handlingView.model,
            })
        );
    },

    showTimeProgramDialogView: function (e, handlingView, timeProgramModel) {
        App.showModal(
            new TimeProgramDialogView({
                handleView: handlingView,
                model: handlingView.model,
                timeProgramModel: timeProgramModel,
                controller: this,
            })
        );
    },

    showSchemaSettingsDialog: function (options) {
        App.showModal(new SchemaSettingsDialogView(options));
    },

    writeFirmwareConfig: function (options) {
        var cfgUpdateReq = App.request('gateway:firmwareconfig:write', options.device, options.config);
        $.when(cfgUpdateReq).done(function (result) {
            if (result === undefined) {
                options.error_cb();
            } else {
                options.success_cb(result);
            }
        });
    },
});

module.exports = ControllerController;
